/* eslint-disable complexity */
import React from "react";
import styles from "./Screenshot.module.css";
import clsx from "clsx";
import { ScreenshotDataModel } from "../ScreenshotSelector";

export type ScreenshotState = "normal" | "loading" | "more" | "send";
export type ScreenshotSize = "small" | "medium" | "large";

interface ScreenshotProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  screenshot?: ScreenshotDataModel;
  state?: ScreenshotState;
  size?: ScreenshotSize;
  showRemoveButton?: boolean;
  onClickView?: () => void;
  onClickSelect?: () => void;
  onRemoveClicked?: () => void;
}

const Screenshot: React.FC<ScreenshotProps> = ({
  screenshot,
  state = "loading",
  size = "medium",
  showRemoveButton,
  onClickView,
  onClickSelect,
  onRemoveClicked,
  ...restProps
}) => {
  return (
    <div
      className={clsx(
        styles["image"],
        styles[size],
        styles[state],
        screenshot?.isSelected && styles["selected"],
        restProps.className
      )}
      onClick={onClickSelect}
      {...restProps}
    >
      {showRemoveButton && (
        <div className={styles["remove-button"]} onClick={onRemoveClicked}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="size-6"
          >
            <path
              fillRule="evenodd"
              d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      )}
      {screenshot && <img src={screenshot.src} />}
      {state === "more" && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v2.25A2.25 2.25 0 0 0 6 10.5Zm0 9.75h2.25A2.25 2.25 0 0 0 10.5 18v-2.25a2.25 2.25 0 0 0-2.25-2.25H6a2.25 2.25 0 0 0-2.25 2.25V18A2.25 2.25 0 0 0 6 20.25Zm9.75-9.75H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.75h-2.25A2.25 2.25 0 0 0 13.5 6v2.25a2.25 2.25 0 0 0 2.25 2.25Z"
          />
        </svg>
      )}
      {state === "send" && (
        <svg
          width="9"
          height="16"
          viewBox="0 0 9 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.22161 16L8.74718 8.60057C9.08427 8.26912 9.08427 7.73088 8.74718 7.39943L1.22161 0L0 1.20113L6.91477 8L0 14.7989L1.22161 16Z"
            fill="currentColor"
          />
        </svg>
      )}
      <div
        className={styles["bottom-section"]}
        onClick={(e) => {
          e.preventDefault();
          onClickView && onClickView();
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="size-6"
        >
          <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
          <path
            fillRule="evenodd"
            d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      {screenshot?.displayOrder && (
        <div className={styles["display-order"]}>
          {screenshot?.displayOrder}
        </div>
      )}
    </div>
  );
};

export default Screenshot;
